export const TRIAL_CONTINUE_TITLE = "Thanks for trying GovernX";

export const TRIAL_CONTINUE_MESSAGE =
  "We hope you enjoyed your trial. You can still look around in read-only — continue with a plan whenever you're ready.";

export const RESTRICTION_COPY = {
  trial_expired: TRIAL_CONTINUE_MESSAGE,
  payment_failed:
    "We couldn't process your last payment. Update billing when you can so connections, jobs, and EMIE stay fully available.",
  cancelled: "Your plan is paused. Reactivate anytime to pick up right where you left off.",
};

export const RESTRICTION_CTA = {
  trial_expired: "Continue with a plan",
  payment_failed: "Update payment",
  cancelled: "Reactivate plan",
};
